export const enum eThemeBasicComponents {
  ApplicationLayout = 'Theme.ApplicationLayoutComponent',
  AccountLayout = 'Theme.AccountLayoutComponent',
  EmptyLayout = 'Theme.EmptyLayoutComponent',
  Logo = 'Theme.LogoComponent',
  Routes = 'Theme.RoutesComponent',
  NavItems = 'Theme.NavItemsComponent',
  CurrentUser = 'Theme.CurrentUserComponent',
  Languages = 'Theme.LanguagesComponent',
}
